import Joi from 'joi';

const ReferralSchema = Joi.object({
  FullName: Joi.string()
    .trim() // Removes leading and trailing spaces
    .pattern(/^[a-zA-Z]*(\s[a-zA-Z]*)+$/) // Updated regex pattern
    .required() // Name is required
    .messages({
      'string.base': 'Name should be a type of text',
      'string.empty': 'Name cannot be empty',
      "string.pattern.base":
        "Full Name must consist of first and last name seperated by space.",
      'any.required': 'Name is required',
    }),

  Email: Joi.string()
    .email({tlds: {allow: false}})
    .required()
    .messages({
      'string.base': 'Email must be a string.',
      'string.empty': 'Email is required.',
      'string.email': 'Email must be a valid email address.',
    }),

  PhoneNumber: Joi.string()
    .pattern(/^\d{10}$/) // Matches exactly 10 digits
    .required()
    .messages({
      'string.pattern.base': 'Mobile number must be a 10-digit number.',
      'any.required': 'Mobile number is required.',
    })
    .required(),

  Street: Joi.string().min(5).max(100).optional().allow('').messages({
    'string.base': 'Street must be a string.',
    // 'string.empty': 'Message is required.',
    'string.min': 'Street must be at least 5 characters long.',
    'string.max': 'Street cannot exceed 100 characters.',
  }),
  Message: Joi.string()
    .pattern(/^\s*\S+(?:\s+\S+)*\s*$/)
    .allow('')
    .optional()
    .messages({
      'string.base': 'Message must be a string.',
      'string.empty': 'Message cannot be empty.',
      'string.pattern.base': 'Message must contain at least one word.',
      'any.required': 'Message is required.',
    }),

  City: Joi.string().min(2).max(50).allow('').optional().messages({
    'string.base': 'City must be a string.',
    // 'string.empty': 'City is required.',
    'string.min': 'City must be at least 2 characters long.',
    'string.max': 'City cannot exceed 50 characters.',
  }),

  State: Joi.string().min(2).max(50).allow('').optional().messages({
    'string.base': 'State must be a string.',
    // 'string.empty': 'State is required.',
    'string.min': 'State must be at least 2 characters long.',
    'string.max': 'State cannot exceed 50 characters.',
  }),

  PostalCode: Joi.string()
    .pattern(/^[0-9]{5}$/)
    .allow('')
    .optional()
    .messages({
      'string.base': 'Postal Code must be a number.',
      // 'string.empty': 'Postal Code is required.',
      'string.pattern.base': 'Postal Code must be exactly 5 digits.',
    }),
});

export default ReferralSchema;
